import React from "react";
import "./RejectBMSConfirmationDialog.css";
import { Button, CircularProgress } from "@mui/material";

const RejectBMSConfirmationDialog = ({
  isOpen,
  onClose,
  onSave,
  onCancel,
  passengerData = {},
  isLoading,
}) => {
  if (!isOpen) return null;

  const { airlineCount = 0, exempted = 0, billableCount = 0 } = passengerData;

  return (
    <div className="reject-bms-modal-overlay">
      <div className="reject-bms-modal-content">
        <div className="reject-bms-modal-header">
          <button className="reject-bms-modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="reject-bms-modal-body">
          <div className="reject-bms-title">
            You have Rejected BMS Count. Below details will saved and this
            flight will be marked as Disputed.
          </div>

          <div className="reject-bms-details">
            <div className="reject-bms-detail-row">
              <span className="reject-bms-label">Airline Count:</span>
              <span className="reject-bms-value">{airlineCount}</span>
            </div>
            <div className="reject-bms-detail-row">
              <span className="reject-bms-label">Exempted:</span>
              <span className="reject-bms-value">{exempted}</span>
            </div>
            <div className="reject-bms-detail-row">
              <span className="reject-bms-label">Billable Count:</span>
              <span className="reject-bms-value">{billableCount}</span>
            </div>
          </div>

          <div className="reject-bms-actions">
            <Button
              className="reject-bms-button save-button"
              variant="contained"
              onClick={!isLoading ? onSave : null}
              endIcon={
                isLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : null
              }
            >
              Save
            </Button>
            <button
              className="reject-bms-button cancel-button"
              onClick={onCancel}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectBMSConfirmationDialog;
